import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref } from "vue";
import { useRoute } from "vue-router";


const __default__ = {
  name: "FavoriteBusStopTypeSelectModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  shouldShow: {
    type: Boolean,
    required: true,
  },
  isAddMode: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onSelectGetOn", "onSelectGetOff", "onClose"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const route = useRoute();
const showModal = ref(true);

const title = computed(() =>
  props.isAddMode ? "도착 알림 유형 선택" : "도착 알림 변경 안내"
);

const modalClass = computed(() =>
  props.isAddMode
    ? "favorite-bus-stop-type-add-modal"
    : "favorite-bus-stop-type-change-modal"
);

const content = computed(() =>
  props.isAddMode
    ? "이 정류장은 승차와 하차 모두 가능합니다. 어떤 용도로 도착 알림을 설정하시겠습니까?"
    : "승차/하차 도착 알림은 각각 1개 정류장만 설정할 수 있습니다. 선택하신 정류장으로 알림을 변경하면 기존 설정은 삭제됩니다. 어떤 용도로 변경하시겠습니까?"
);

const getOnButtonText = computed(() =>
  props.isAddMode ? "승차 알림 설정" : "승차 알림 변경"
);

const getOffButtonText = computed(() =>
  props.isAddMode ? "하차 알림 설정" : "하차 알림 변경"
);

const closeModal = () => {
  route.meta.onBackHandlerList.pop();
  showModal.value = false;
  setTimeout(() => {
    emit("onClose");
  }, 300);
};

const onClickGetOnButton = () => {
  route.meta.onBackHandlerList.pop();
  emit("onSelectGetOn");
  closeModal();
};

const onClickGetOffButton = () => {
  route.meta.onBackHandlerList.pop();
  emit("onSelectGetOff");
  closeModal();
};

onMounted(() => {
  route.meta.onBackHandlerList.push(closeModal);
});

const __returned__ = { props, emit, route, showModal, title, modalClass, content, getOnButtonText, getOffButtonText, closeModal, onClickGetOnButton, onClickGetOffButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})